<template>
  <div v-if="message" class="app-error-modal-overlay" @click="$emit('close')">
    <div class="app-error-modal-content" @click.stop>
      <div class="app-error-modal-header">
        <div class="app-error-icon">{{ icon }}</div>
        <h3>{{ title }}</h3>
        <button @click="$emit('close')" class="app-error-modal-close">&times;</button>
      </div>
      <div class="app-error-modal-body">
        <div class="app-error-main-message">
          <p>{{ message }}</p>
        </div>
      </div>
      <div class="app-error-modal-actions">
        <button @click="$emit('close')" class="btn-primary">Tamam</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppErrorModal',
  props: {
    message: { type: String, default: '' },
    title: { type: String, default: 'Hata Oluştu' },
    icon: { type: String, default: '⚠️' }
  },
  emits: ['close']
}
</script>

<style scoped>
.app-error-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-out;
}

.app-error-modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.app-error-modal-header {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  color: white;
  padding: 1.5rem;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-error-icon {
  font-size: 2.5rem;
  margin-right: 1rem;
}

.app-error-modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  flex: 1;
}

.app-error-modal-close {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.app-error-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-50%) scale(1.1);
}

.app-error-modal-body {
  padding: 2rem;
  text-align: left;
}

.app-error-main-message {
  padding: 1rem;
  background: linear-gradient(135deg, #fff5f5, #fed7d7);
  border-radius: 12px;
  border-left: 4px solid #f56565;
}

.app-error-main-message p {
  margin: 0;
  font-size: 1.1rem;
  color: #c53030;
  line-height: 1.6;
  font-weight: 500;
}

.app-error-modal-actions {
  padding: 1.5rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.app-error-modal-actions .btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.app-error-modal-actions .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

@media (max-width: 768px) {
  .app-error-modal-content {
    max-width: 92%;
    margin: 1rem;
  }
  .app-error-modal-header {
    padding: 1.2rem;
  }
  .app-error-icon {
    font-size: 2rem;
  }
  .app-error-modal-header h3 {
    font-size: 1.2rem;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
